import React, { useEffect, useMemo, useState } from "react";
import Tabs from "@mui/material/Tabs";
import { Spinner } from "react-bootstrap";
import Tab from "@mui/material/Tab";
import CategoryIcon from "@mui/icons-material/Category";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { styled } from "@mui/material/styles";
import CategoryAlert from "./components/categoryAlert/categoryAlert";
import ServiceAlert from "./components/serviceAlert/serviceAlert";
import { baseUrl } from "../../../../network/constants/constants";
import { getConfig } from "../../../../network/auth";
import axios from "../../../../network/api";
import WorkerCancelAlert from "./components/workerCancelAlert/workerCancelAlert";
import EngineeringIcon from '@mui/icons-material/Engineering';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import CustomerCancelAlert from "./components/customerCancelAlert/customerCancelAlert";
import RejectedJob from "./components/rejectedJob";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
};

const Alert = () => {
  const [value, setValue] = React.useState(0);
  const [loading, setLoading] = useState(false);
  const [categoryAlert, setCategoryAlert] = useState([]);
  const [serviceAlert, setServiceAlert] = useState([]);
  const [categoryPending, setCategoryPending] = useState([]);
  const [categoryResponded, setCategoryResponded] = useState([]);
  const [servicePending, setServicePending] = useState([]);
  const [serviceResponded, setServiceResponded] = useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const StyledTab = styled(Tab)({
    "&.Mui-selected": {
      color: "#ff4d4d",
    },
  });

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const fetchAlerts = () => {
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/alerts/`, config)
      .then((response) => {
        
       
        const alertArray = response.data;
        const categoryAlertData = alertArray.filter(
          (item) => item.type === "Category"
        );
        const serviceAlertData = alertArray.filter(
          (item) => item.type === "Service"
        );

        const pendingCategory = categoryAlertData.filter(
          (item) => item.status === "Pending"
        );
        const nonPendingCategory = categoryAlertData.filter(
          (item) => item.status !== "Pending"
        );
        const pendingService = serviceAlertData.filter(
          (item) => item.status === "Pending"
        );
        const nonPendingService = serviceAlertData.filter(
          (item) => item.status !== "Pending"
        );
        setCategoryAlert(
          categoryAlertData.map((alert, index) => ({
            ...alert,
            displayIndex: index + 1,
          }))
        ); 
        setServiceAlert(serviceAlertData.map((alert, index) => ({
          ...alert,
          displayIndex: index + 1,
        })));
        setCategoryPending(pendingCategory.map((alert, index) => ({
          ...alert,
          displayIndex: index + 1,
        })));
        setCategoryResponded(nonPendingCategory.map((alert, index) => ({
          ...alert,
          displayIndex: index + 1,
        })));
        setServicePending(pendingService.map((alert, index) => ({
          ...alert,
          displayIndex: index + 1,
        })));
        setServiceResponded(nonPendingService.map((alert, index) => ({
          ...alert,
          displayIndex: index + 1,
        })));
        setLoading(false);
      })
      .catch((error) => {
        console.error("Category Edit Error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchAlerts();
  }, []);

  return (
    <>
      {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="icon label tabs example"
            TabIndicatorProps={{
              style: {
                backgroundColor: "#ff4d4d",
              },
            }}
          >
            <StyledTab
              sx={{ textTransform: "none" }}
              icon={<CategoryIcon />}
              iconPosition="start"
              label="Category Alert"
            />
            <StyledTab
              sx={{ textTransform: "none" }}
              icon={<FormatListBulletedIcon />}
              iconPosition="start"
              label="Service Alert"
            />
             <StyledTab
              sx={{ textTransform: "none" }}
              icon={<EngineeringIcon />}
              iconPosition="start"
              label="Worker Cancelled Alert"
            />
              <StyledTab
              sx={{ textTransform: "none" }}
              icon={<AccountBoxIcon />}
              iconPosition="start"
              label="Customer Cancelled Alert"
            />
              <StyledTab
              sx={{ textTransform: "none" }}
              icon={<AccountBoxIcon />}
              iconPosition="start"
              label="Rejected Job Alert"
            />
          </Tabs>
          <TabPanel value={value} index={0}>
            <CategoryAlert
              categoryAlert={categoryAlert}
              categoryPending={categoryPending}
              categoryResponded={categoryResponded}
              fetchAlerts={fetchAlerts}
              loading={loading}
              setLoading={setLoading}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <ServiceAlert
              serviceAlert={serviceAlert}
              servicePending={servicePending}
              serviceResponded={serviceResponded}
              fetchAlerts={fetchAlerts}
              loading={loading}
              setLoading={setLoading}
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <WorkerCancelAlert/>
          </TabPanel>
          <TabPanel value={value} index={3}>
            <CustomerCancelAlert/>
          </TabPanel>
          <TabPanel value={value} index={4}>
            <RejectedJob/>
          </TabPanel>
        </>
      )}
    </>
  );
};

export default Alert;
